import messages from "@smartmixin/i18n/dist/translations/ru.json";

export default messages;
